<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__member}">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item v-if="visible">
                    <el-select v-model="dataForm.orgId" placeholder="请选择区域">
                        <el-option label="全选" value="" key=""></el-option>
                        <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.mobile" placeholder="手机号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
<!--                <el-form-item>-->
<!--                    <el-input v-model="dataForm.parentInvitationCode" placeholder="上级邀请码" clearable></el-input>-->
<!--                </el-form-item>-->
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="$hasPermission('pms:umsmember:partnerApplyExport')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
<!--                <el-form-item>-->
<!--                    <el-button v-if="$hasPermission('pms:umsmember:save')" type="primary" @click="addOrUpdateHandle()">-->
<!--                        {{ $t('add') }}-->
<!--                    </el-button>-->
<!--                </el-form-item>-->
<!--                <el-form-item>-->
<!--                    <el-button v-if="$hasPermission('pms:umsmember:delete')" type="danger" @click="deleteHandle()">{{-->
<!--                        $t('deleteBatch') }}-->
<!--                    </el-button>-->
<!--                </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
<!--                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <!--        <el-table-column prop="id" label="ID" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="orgName" label="所属区域" header-align="center" align="center"></el-table-column>
                <el-table-column prop="nick" label="昵称" header-align="center" align="center"></el-table-column>
                <el-table-column label="头像" width="150" header-align="center" align="center">
                    <template slot-scope="scope">
                        <img :src="scope.row.avatar" alt="" width="100" height="100">
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobile" label="手机号" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="password" label="密码" header-align="center" align="center"></el-table-column>-->
<!--                <el-table-column prop="gender" label="性别" header-align="center" align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-tag v-if="scope.row.partnerApplyStatus===0">未知</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.partnerApplyStatus===1">男</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.partnerApplyStatus===2">女</el-tag>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="level" label="会员等级" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.level===0">优客</el-tag>
                        <el-tag v-else-if="scope.row.level===1">节点</el-tag>
                        <el-tag v-else-if="scope.row.level===2">法人</el-tag>
                        <el-tag v-else-if="scope.row.level===3">合伙人</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="certificationStatus"  label="认证情况" header-align="center"
                                 align="center"></el-table-column>
<!--                <el-table-column prop="invitationCode" label="邀请码" header-align="center"-->
<!--                                 align="center"></el-table-column>-->
                <el-table-column prop="identityCardNumber" label="身份证号" header-align="center"
                                 align="center"></el-table-column>
<!--                <el-table-column prop="identityCardAddress" label="身份证地址" header-align="center"-->
<!--                                 align="center"></el-table-column>-->
                <!--        <el-table-column prop="identityCardPicture" label="身份证图片" header-align="center" align="center"></el-table-column>-->
<!--                <el-table-column prop="purchaseNumber" label="购买节点个数" header-align="center"-->
<!--                                 align="center"></el-table-column>-->
<!--                <el-table-column prop="cashBalance" label="余额" header-align="center"-->
<!--                                 align="center"></el-table-column>-->
<!--                <el-table-column prop="integrationBalance" label="优果" header-align="center"-->
<!--                                 align="center"></el-table-column>-->
                <el-table-column prop="agentAreaCode" label="申请代理区域" header-align="center"
                                 align="center"></el-table-column>
<!--                <el-table-column prop="partnerApplyStatus" label="合伙人申请状态" header-align="center" align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-tag v-if="scope.row.partnerApplyStatus===0">未申请</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.partnerApplyStatus===1">审核中</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.partnerApplyStatus===2">已通过</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.partnerApplyStatus===3">已拒绝</el-tag>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="juridicalApplyStatus" label="法人申请状态" header-align="center" align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-tag v-if="scope.row.juridicalApplyStatus===0">未申请</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.juridicalApplyStatus===1">审核中</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.juridicalApplyStatus===2">已通过</el-tag>-->
<!--                        <el-tag v-else-if="scope.row.juridicalApplyStatus===3">已拒绝</el-tag>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <!--        <el-table-column prop="lastLoginTime" label="最后登录时间" header-align="center" align="center"></el-table-column>-->
                        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>-->
                <el-table-column label="审批" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
<!--                        <el-button v-if="scope.row.juridicalApplyStatus===1" type="text" size="small"-->
<!--                                   @click="memberJuridicalCheck(scope.row.id)">法人审批-->
<!--                        </el-button>-->
                        <el-button v-if="scope.row.partnerApplyStatus===1&&$hasPermission('pms:umsmember:partnerApply')" type="text" size="small"
                                   @click="memberPartnerCheck(scope.row.id)">合伙人审批
                        </el-button>
                        <!--            <el-button v-if="scope.row.partnerApplyStatus===1" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>-->
                        <!--            <el-button v-if="$hasPermission('pms:umsmember:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <MemberJuridicalApply v-if="memberJuridicalApplyVisible" ref="MemberJuridicalApply"
                                  @refreshDataList="getDataList"></MemberJuridicalApply>
            <member-partner-apply v-if="memberPartnerApplyVisible" ref="MemberPartnerApply"
                                  @refreshDataList="getDataList"></member-partner-apply>
        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './member-add-or-update'
    import MemberJuridicalApply from './member-juridicalApply'
    import MemberPartnerApply from './member-partnerApply'

    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                memberJuridicalApplyVisible: false,
                memberPartnerApplyVisible: false,
                visible: false,
                orgList: [],
                ApplyStatus: [{
                    value: 0,
                    label: '未申请'
                }, {
                    value: 1,
                    label: '审核中'
                }, {
                    value: 2,
                    label: '已通过'
                }, {
                    value: 3,
                    label: '已拒绝'
                }],
                mixinViewModuleOptions: {
                    getDataListURL: '/pms/umsmember/partnerApplyPage',
                    getDataListIsPage: true,
                    exportURL: '/pms/umsmember/partnerApplyExport',
                    deleteURL: '/pms/umsmember/member',
                    deleteIsBatch: true,
                    activatedIsNeed: false
                },
                dataForm: {
                    id: '',
                    name: '',
                    mobile: '',
                    identityCardAddress: '',
                    agentAreaCode: '',
                    allApplyStatus: '',
                    parentInvitationCode: '',
                    orgId: '',
                    orgName:'',
                    isHead:false
                }
            }
        },
        mounted() {
            const that = this;
            that.getInfo();
        },
        methods: {
            memberJuridicalCheck(id) {
                this.memberJuridicalApplyVisible = true
                this.$nextTick(() => {
                    this.$refs.MemberJuridicalApply.init(id)
                })
            },
            getInfo() {
                this.$http.get(`/sys/user/info`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.orgId=res.data.orgId
                    this.dataForm.orgName=res.data.orgName
                    this.dataForm.isHead=res.data.isHead;
                    if (this.dataForm.isHead) {
                        this.visible=true;
                        this.getOrgList();
                    }
                    if(!this.mixinViewModuleOptions.activatedIsNeed){
                        this.getDataList()
                    }
                }).catch(() => {
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/select').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            },
            memberPartnerCheck(id) {
                this.memberPartnerApplyVisible = true
                this.$nextTick(() => {
                    this.$refs.MemberPartnerApply.init(id)
                })
            }
        },
        components: {
            AddOrUpdate,
            MemberJuridicalApply,
            MemberPartnerApply
        }
    }
</script>
